import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { getGetChecklistQueryOptions } from '@area-restrita/api-client/endpoints/hang-tag/hang-tag.gen';

import EditCheckList from '@/modules/hang-tags/pages/EditCheckList';

export const Route = createFileRoute(
  '/_authenticated/_system/_tenant/settings/hang-tag/check-list/$checklistId',
)({
  head: () => ({
    meta: [{ title: 'Editar Check List' }],
  }),
  parseParams: (params) =>
    z.object({ checklistId: z.coerce.number() }).parse(params),
  loader: async ({ params, context: { queryClient } }) => {
    const data = await queryClient.ensureQueryData(
      getGetChecklistQueryOptions(params.checklistId),
    );

    return data;
  },
  component: function EditCheckListRoute() {
    const checkList = Route.useLoaderData();

    return <EditCheckList checkList={checkList} />;
  },
});
